import { Helpers } from "../../helpers";

class SingleChoiceModel {

    constructor(id, responseList, weightList, outputs) {

        if(!Helpers.isInteger(id))
            throw new Error(`'id' argument must be an Integer`);
            
        this._id = id;

        this.setResponses(responseList);
        this.setWeights(weightList);
        this.setOutputs(outputs);
    }

    export() {

        return {

            id: this._id,
            type: 'single-choice',
            choices: this._exportFollowups()
        };
    }

    _exportFollowups() {

        let followups = [];

        for(let i=0; i< this._responseList.length; i++) {

            followups.push({

                text: this._responseList[i],
                weight: this._weightList[i],
                followup: this._outputs[i]
            });
        }

        return followups;
    }

    isId(id) {

        return this._id === id;
    }

    getId() {

        return this._id;
    }

    getOutputs() {

        return this._outputs;
    }
    
    getOutput(index) {

        return this._outputs[index];
    }    

    getOutputCount() {

        return this._outputs.length;
    }

    setOutputs(outputs) {

        if(Helpers.isDefined(outputs))
            if(!Helpers.isArray(outputs) || outputs.length !== this._responseList.length)
                throw new Error(`'outputs' argument must be an Array of length 'responseList'`);

        if(Helpers.isDefined(outputs)) {

            this._outputs = outputs;
        }
        else 
        if(Helpers.isUndefined(this._outputs) || this._outputs.length !== this._responseList.length) {

            this._outputs = [];

            for(let i=0; i<this._responseList.length; i++)
                this._outputs.push(null);
        }
    }

    setOutput(index, value) {

        if(!Helpers.isIndexInBounds(index, this._outputs.length))
            throw new Error(`Index out of bounds`);

        if(!(Helpers.isInteger(value) || value === null))
            throw new Error(`'value' argument must be an Integer or null`);

        this._outputs[index] = value;
    }

    getResponses() {

        return this._responseList;
    }
    
    getResponse(index) {

        return this._responseList[index];
    }    

    getResponseCount() {

        return this._responseList.length;
    }

    setResponses(responseList) {

        if(!Helpers.isArray(responseList))
            throw new Error(`'responseList' argument must be an array of Strings`);

        if(responseList.length < 1)
            throw new Error(`Single-statement element must have at least 1 responses`);

        for(let response of responseList)
            if(!Helpers.isString(response))
                throw new Error(`'responseList' argument elements must be Strings`);

        this._responseList = responseList;

        if(Helpers.isUndefined(this._outputs) || this._outputs.length !== responseList.length) {

            this._outputs = [];

            for(let i=0; i<this._responseList.length; i++)
                this._outputs.push(null);
        }
    }

    setResponse(index, value) {

        if(!Helpers.isIndexInBounds(index, this._responseList.length))
            throw new Error(`Index out of bounds`);
    
        if(!Helpers.isString(value))
            throw new Error(`'value' argument must be a String`);

        this._responseList[index] = value;
    }

    addResponse(responseText, position) {

        if(Helpers.isUndefined(position)) {

            this._responseList.push(responseText);
            this._outputs.push(null);
        }
        else {

            if(!Helpers.isIndexInBounds(position, this._responseList.length))
                throw new Error(`Index out of bounds`);

            this._responseList.splice(position, 0, responseText);
            this._outputs.splice(position, 0, null);
        }
    }

    deleteResponse(index) {
        
        if(this._responseList.length <= 2)
            throw new Error(`Single-statement element must have at least 2 responses`);

        if(!Helpers.isIndexInBounds(index, this._responseList.length))
            throw new Error(`Index out of bounds`);

        this._responseList.splice(index, 1);
        this._outputs.splice(index, 1);
    }

    getWeights() {

        return this._weightList;
    }
    
    getWeight(index) {

        return this._weightList[index];
    }    

    getWeightCount() {

        return this._weightList.length;
    }

    setWeights(weightList) {

        if(!Helpers.isArray(weightList))
            throw new Error(`'weightList' argument must be an array of Numbers`);

        if(weightList.length !== this._responseList.length)
            throw new Error(`Single-statement element must have 1 weight for each response`);

        for(let weight of weightList)
            if(!Helpers.isNumber(weight))
                throw new Error(`'weightList' argument elements must be Number`);

        this._weightList = weightList;
    }

    setWeight(index, value) {

        if(!Helpers.isIndexInBounds(index, this._weightList.length))
            throw new Error(`Index out of bounds`);
    
        if(!Helpers.isString(value))
            throw new Error(`'value' argument must be a String`);

        this._weightList[index] = value;
    }

    addWeight(responseText, position) {

        if(Helpers.isUndefined(position)) {

            this._weightList.push(responseText);
            this._outputs.push(null);
        }
        else {

            if(!Helpers.isIndexInBounds(position, this._weightList.length))
                throw new Error(`Index out of bounds`);

            this._weightList.splice(position, 0, responseText);
            this._outputs.splice(position, 0, null);
        }
    }

    deleteWeight(index) {
        
        if(this._weightList.length <= 2)
            throw new Error(`Single-statement element must have at least 2 responses`);

        if(!Helpers.isIndexInBounds(index, this._weightList.length))
            throw new Error(`Index out of bounds`);

        this._weightList.splice(index, 1);
        this._outputs.splice(index, 1);
    }
}

export default SingleChoiceModel;